import FluentValidator from '@/app/module/fluentValidator'

class Validator extends FluentValidator {
  public validateInputAccount (key: string, value: number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'ユーザー種別は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputName (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '氏名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputTel (key: string, value: string) {
    this.errorMessages[key] = ''

    if (value && !(value.match(/^[\d-]*$/))) {
      this.errorMessages[key] = '電話番号は数字と-で入力してください。'
      return false
    }
    return true
  }

  public validateInputEmail (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'メールアドレスは必ず入力してください。'
      return false
    } else if (value.match(/^([a-zA-Z0-9])+([a-zA-Z0-9._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9._-]+)+$/) === null) {
      this.errorMessages[key] = '正しいメールアドレスの形式で入力してください。'
      return false
    }
    return true
  }

  public validateInputPassword (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'パスワードは必ず入力してください。'
      return false
    } else if (!(value.match(/^[a-z\d!"'#$%&()_-]{6,128}$/i))) {
      this.errorMessages[key] = 'パスワードは半角英数字6文字以上128文字以内で入力してください。'
      return false
    }
    return true
  }

  public validateInputConfirmPassword (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '確認用パスワードは必ず入力してください。'
      return false
    } else if (!(value.match(/^[a-z\d!"'#$%&()_-]{6,128}$/i))) {
      this.errorMessages[key] = 'パスワードは半角英数字6文字以上128文字以内で入力してください。'
      return false
    }
    return true
  }

  public validateInputGroup (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'グループは必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputGroupName (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'グループ名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputAreaID (key: string, value: number) {
    this.errorMessages[key] = ''

    if (!value || value === 0) {
      this.errorMessages[key] = '地域名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputAiAdviceName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'AIアドバイス名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputDistrictCode (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '地区コードは必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputSortNumber (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '並び順は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputRiskName (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = 'リスク名は必ず入力してください。'
      return false
    }
    return true
  }

  // マスター
  public validateInputVarietyName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '品種名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputVarietyGrowthName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '品種生育名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateSelectVarietyGrowthName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '品種生育は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputUserName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '記録者は必ず入力してください。'
      return false
    }
    return true
  }

  public validateSelectUserName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '生産者は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputDistrictName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '地区名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputFieldName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '圃場名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputStartDate (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '開始日は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputEndDate (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '終了日は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputAreaName (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '地域名は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputYield (key: string, value: string|number) {
    this.errorMessages[key] = ''

    if (value) {
      if (value < 0 || value > 10000000) {
        this.errorMessages[key] = '反収は0以上10,000,000以下の範囲ではありません。'
        return false
      }
    }
    return true
  }

  public validateInputPlantingDate (key: string, value: string) {
    this.errorMessages[key] = ''

    if (!value) {
      this.errorMessages[key] = '播種日は必ず入力してください。'
      return false
    }
    return true
  }

  public validateInputActualYieldPrice (key: string, value: number) {
    this.errorMessages[key] = ''

    if (value) {
      if (!Number.isInteger(value) || value < 0 || value > 100000000) {
        this.errorMessages[key] = '収量単価は0以上100,000,000以下の範囲で入力してください。'
        return false
      }
    }
    return true
  }

  public validateInputPlanYieldSum (key: string, value: number) {
    this.errorMessages[key] = ''

    if (value) {
      if (value < 0 || value > 10000000000) {
        this.errorMessages[key] = '見込収量は0以上10,000,000,000以下の範囲ではありません。'
        return false
      }
    }
    return true
  }

  public validateInputIncome (key: string, value: number) {
    this.errorMessages[key] = ''

    if (value) {
      if (value < 0 || value > 10000000000) {
        this.errorMessages[key] = '収入は0以上10,000,000,000以下の範囲ではありません。'
        return false
      }
    }
    return true
  }

  public validateInputActualYieldSum (key: string, value: number) {
    this.errorMessages[key] = ''

    if (value) {
      if (value < 0 || value > 100000000) {
        this.errorMessages[key] = '収量は0以上100,000,000以下の範囲ではありません。'
        return false
      }
    }
    return true
  }

  public validateInputFieldColor (key: string, value: string) {
    this.errorMessages[key] = ''

    if (value && !(value.match(/^#([0-9a-fA-F]{6})$/i))) {
      this.errorMessages[key] = '圃場カラーは先頭が#かつ0-9、a-f、A-Fの6桁で入力してください。'
      return false
    }
    return true
  }

  public validateInputPlantColor (key: string, value: string) {
    this.errorMessages[key] = ''

    if (value && !(value.match(/^#([0-9a-fA-F]{6})$/i))) {
      this.errorMessages[key] = '作付けカラーは先頭が#かつ0-9、a-f、A-Fの6桁で入力してください。'
      return false
    }
    return true
  }

  public validateInputFieldArea (key: string, value: number) {
    this.errorMessages[key] = ''
    const decimalPointLength = String(value).split('.')

    if (value === null) {
      this.errorMessages[key] = '圃場面積(㎡)は必ず入力してください。'
      return false
    } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
      this.errorMessages[key] = '圃場面積(㎡)は小数点第1位までの範囲で入力してください。'
      return false
    } else if (value < 0 || value > 100000000) {
      this.errorMessages[key] = '圃場面積(㎡)は0以上100,000,000以下の範囲で入力してください。'
      return false
    }
    return true
  }

  // 品種生育
  public validateInputHarvestCorrectionMinus (key: string, value: number) {
    this.errorMessages[key] = ''

    if (value) {
      if (value < 0 || value > 20) {
        this.errorMessages[key] = '収穫適期補正は0以上20以下の範囲で入力してください。'
        return false
      } else if (!Number.isInteger(value)) {
        this.errorMessages[key] = '収穫適期補正は整数で入力してください。'
        return false
      }
    }
    return true
  }
  public validateInputHarvestCorrectionPlus (key: string, value: number) {
    this.errorMessages[key] = ''

    if (value) {
      if (value < 0 || value > 20) {
        this.errorMessages[key] = '収穫適期補正は0以上20以下の範囲で入力してください。'
        return false
      } else if (!Number.isInteger(value)) {
        this.errorMessages[key] = '収穫適期補正は整数で入力してください。'
        return false
      }
    }
    return true
  }

  public validateInputNewsBoardName (key: string, value: string) {
    this.errorMessages[key] = ''
    const maxLength = 8

    if (!value) {
      this.errorMessages[key] = '栽培指導広報名称は必ず入力してください。'
      return false
    } else if (value.length > maxLength) {
      this.errorMessages[key] = '栽培指導広報名称は' + String(maxLength) + '文字以下で入力してください。'
      return false
    }
    return true
  }

  public validateInputExternalLinkName (key: string, value: string) {
    this.errorMessages[key] = ''
    const maxLength = 8

    if (!value) {
      this.errorMessages[key] = '外部連携名称は必ず入力してください。'
      return false
    } else if (value.length > maxLength) {
      this.errorMessages[key] = '外部連携名称は' + String(maxLength) + '文字以下で入力してください。'
      return false
    }
    return true
  }

  public validateInputEmergencyAlertMessage (key: string, value: string) {
    this.errorMessages[key] = ''
    const maxLength = 25

    if (!value) {
      this.errorMessages[key] = 'アラートテキストは必ず入力してください。'
      return false
    } else if (value.length > maxLength) {
      this.errorMessages[key] = 'アラートテキストは' + String(maxLength) + '文字以下で入力してください。'
      return false
    }
    return true
  }

  public validateInputEmergencyAlertLink (key: string, value: string) {
    this.errorMessages[key] = ''
    const maxLength = 2000

    if (value) {
      if (value.length > maxLength) {
        this.errorMessages[key] = 'リンク先URLは' + String(maxLength) + '文字以下で入力してください。'
        return false
      }
    }
    return true
  }

  public getErrorMessage () {
    return this.errorMessages
  }
}

export default new Validator()
